import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: '',
  content: `
    <p class="mb-4 text-lg font-medium">
      Positiv denken ist eine der gefährlichsten Strategien der modernen Persönlichkeitsentwicklung.
    </p>
    
    <p class="mb-4">
      Das ist keine Übertreibung. Es ist eine klinische Beobachtung. In meiner Arbeit mit Führungskräften und Unternehmern sehe ich täglich die verheerenden Folgen dieses kulturellen Dogmas: Intelligente, fähige Menschen, die gelernt haben, die wichtigsten Warnsignale ihres inneren Betriebssystems zu übermalen, bis die Festplatte unweigerlich crasht.
    </p>
    
    <p class="mb-4">
      Dieser Artikel ist kein Plädoyer für Pessimismus. Er ist ein Plädoyer für Realismus. Er ist eine Anleitung, wie du von der oberflächlichen Selbst-Manipulation zur tiefen Selbst-Regulation gelangst.
    </p>
  `
};
